<template>
  <div class="search-main">
    <div
      class="file-header search-header nav-bar-bgcolor"
    >
      <van-field
        type="search"
        ref="field"
        v-model="searchText"
        :placeholder="placeholder"
        left-icon="search"
        maxlength="100"
        clearable
        @compositionstart="onCompositionStart"
        @compositionend="onCompositionEnd"
        @input="onInput"
        @keyup.enter="onEnter"
      />
      <div class="cancel-btn" @click="onClose">{{$t('base.cancel')}}</div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import Tabs from './Tabs'
export default {
  name: 'SearchPopup',
  i18n,
  components: {
    Tabs
  },
  props: {
    show: Boolean,
    value: String,
    placeholder: String,
    filters: Array,
    defaultTab: String
  },
  model: {
    prop: 'value',
    event: 'on-search'
  },
  data () {
    return {
      searchText: this.$route.query.search_text
    }
  },
  watch: {
    $route (to) {
      this.searchText = to.query.search_text
    },
    show (val, oldVal) {
      if (val && !oldVal) {
        // this.searchText = this.$route.query.search_text

        // 返回键到达搜索页面 不聚焦
        if (!this.searchText) {
          this.$refs.field.$refs.input.focus()
        }
      }
    }
  },
  methods: {
    onClose () {
      this.$emit('close-search')
    },
    onInput (value) {
      this.$emit('on-search', value)
    },
    onEnter () {
      this.$refs.field.$refs.input.blur()
    },
    onCompositionStart () {
      this.inputing = true
    },
    onCompositionEnd () {
      this.inputing = false
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.search-view {
  width: 100%;
  height: 100%;
}

.search-main {
  height: 100%;
  display: flex;
  flex-direction: column;

  & .search-header {
    height: 50px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 10px 15px;
    flex: 0 0 auto;

    & .van-field {
      padding: 0 10px;
      height: 28px;
      line-height: 28px;
      border-radius: 5px;
      background-color: #5b8ce1;
      color: #fff;

      & input,
      & .van-icon {
        color: #fff;
        line-height: 28px
      }

      & input {

        &::selection {
          background-color: #fff
        }

        &::-webkit-input-placeholder {
          color: #fff;
          color: rgba(255, 255, 255, .5);
        }

        &::-webkit-search-cancel-button{
          display: none;
        }
      }

      &::after {
        border: 0
      }
    }

    & .cancel-btn {
      flex: 0 0 auto;
      padding-left: 10px;
      font-size: 16px;
    }
  }
}
</style>
